import React from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../components/SafeIcon';
import { FiStar, FiMap, FiExternalLink, FiNavigation } from 'react-icons/fi';
import { placesData } from '../data/mockData';

export default function PlacesView() {
  return (
    <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} exit={{ opacity: 0, y: -20 }}>
      <div className="flex justify-between items-end mb-8">
        <div>
          <h2 className="text-2xl font-mono text-white mb-2">SAVED LOGISTIC POINTS</h2>
          <p className="text-gray-400 text-sm">Key coordinates for your mission.</p>
        </div>
        <div className="flex gap-3">
          <button className="flex items-center gap-2 px-4 py-2 rounded-lg bg-white/5 border border-white/10 text-gray-400 text-xs font-mono hover:text-white transition-all">
            <SafeIcon icon={FiMap} />
            <span className="hidden sm:inline">SAT_VIEW</span>
          </button>
          <button className="flex items-center gap-2 px-4 py-2 rounded-lg bg-cyan-400/10 border border-cyan-400/30 text-cyan-400 text-xs font-mono hover:bg-cyan-400/20 transition-all">
            <SafeIcon icon={FiNavigation} />
            <span className="hidden sm:inline">MAPPED_LANE</span>
          </button>
        </div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {placesData.map((place, idx) => (
          <motion.div
            initial={{ opacity: 0, scale: 0.95 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ delay: idx * 0.1 }}
            key={place.id}
            className="glass-card group flex flex-col h-full overflow-hidden border border-white/5 hover:border-cyan-400/30 transition-all duration-500"
          >
            <div className="relative h-56 w-full overflow-hidden">
              <div className="absolute inset-0 bg-gradient-to-t from-midnight-900 via-transparent to-transparent z-10 opacity-60"></div>
              <img 
                src={place.img} 
                alt={place.name} 
                className="w-full h-full object-cover transform group-hover:scale-110 transition-transform duration-1000" 
              />
              <div className="absolute top-4 right-4 z-20 flex items-center gap-1.5 bg-midnight-900/80 backdrop-blur-md px-2.5 py-1 rounded-full border border-white/10 shadow-lg">
                <SafeIcon icon={FiStar} className="text-coral-400 text-xs" />
                <span className="text-[10px] font-mono font-bold text-white tracking-widest">{place.rating}</span>
              </div>
              <div className="absolute bottom-4 left-4 z-20">
                <span className="px-2 py-0.5 rounded bg-cyan-400 text-midnight-900 text-[9px] font-mono font-black uppercase tracking-widest">
                  {place.type}
                </span>
              </div>
            </div>
            
            <div className="p-6 flex-1 flex flex-col">
              <div className="mb-6 flex-1">
                <h3 className="text-xl font-bold text-white mb-2 group-hover:text-cyan-400 transition-colors tracking-tight">{place.name}</h3>
                <p className="text-xs text-gray-500 font-mono tracking-tighter uppercase">{place.reviews} verified reviews in sector</p>
              </div>
              
              <div className="flex gap-2">
                <button className="flex-1 py-2.5 rounded-xl bg-white/5 border border-white/10 text-[10px] font-mono text-gray-400 hover:text-white hover:bg-white/10 transition-all uppercase tracking-widest">
                  Details
                </button>
                <button className="w-12 h-10 flex items-center justify-center rounded-xl bg-cyan-400 text-midnight-900 hover:bg-white transition-all shadow-[0_0_15px_rgba(0,240,255,0.2)]">
                  <SafeIcon icon={FiExternalLink} className="text-lg" />
                </button>
              </div>
            </div>
          </motion.div>
        ))}
      </div>
    </motion.div>
  );
}